import { render } from "./EditableTeamMembers.vue?vue&type=template&id=507ecf8e"
import script from "./EditableTeamMembers.vue?vue&type=script&lang=js"
export * from "./EditableTeamMembers.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__